export interface CreateLlmDbAiPayload {
  displayName: string
  systemVersion: string
  status: string
  modelType: string
  llmType: string
  deploymentName: string
  modelName: string
  apiType: string
  apiBaseUrl: string
  apiVersion: string
  apiSecretKey: string
  apiSecretValue: string
  functionCallingEnabled: string
  tenantScope: string
  tenantIds: string[]
  loggedTenantId: string
  isTenantAdmin: boolean
  productId: string
  llmParameters: { name: string; value: string }[]
  id?: string
}

export const AI_PAYLOAD_STRING_KEYS = [
  'displayName',
  'systemVersion',
  'status',
  'modelType',
  'llmType',
  'deploymentName',
  'modelName',
  'apiType',
  'apiBaseUrl',
  'apiVersion',
  'apiSecretKey',
  'apiSecretValue',
  'functionCallingEnabled',
  'tenantScope',
  'loggedTenantId',
  'productId',
] as const satisfies readonly (keyof CreateLlmDbAiPayload)[]

export interface CreateLlmDbDbPayload {
  displayName: string
  toolKey: string
  connectionHost: string
  port: string
  databaseName: string
  status: string
  tenantId: string
  productId: string
  notes: string
}

export interface CreateLlmDbFormProps {
  variant: 'ai' | 'db'
  onCancel: () => void
  onSave?: (payload: CreateLlmDbAiPayload | CreateLlmDbDbPayload) => void | Promise<unknown>
  initialRecord?: Record<string, unknown> | null
  modalTitle?: string
}

export type AiState = {
  displayName: string
  systemVersion: string
  status: string
  modelType: string
  llmType: string
  deploymentName: string
  modelName: string
  apiType: string
  apiBaseUrl: string
  apiVersion: string
  apiSecretKey: string
  apiSecretValue: string
  functionCallingEnabled: string
  tenantScope: '' | 'basic' | 'specific'
  productId: string
}

export type DbState = {
  displayName: string
  toolKey: string
  connectionHost: string
  port: string
  databaseName: string
  status: string
  tenantId: string
  productId: string
  notes: string
}

export type LlmParam = { id: string; name: string; value: string }
export type LlmParamErrors = Record<string, { name?: boolean; value?: boolean }>

export const INITIAL_AI_STATE: AiState = {
  displayName: '',
  systemVersion: '',
  status: '',
  modelType: '',
  llmType: '',
  deploymentName: '',
  modelName: '',
  apiType: '',
  apiBaseUrl: '',
  apiVersion: '',
  apiSecretKey: '',
  apiSecretValue: '',
  functionCallingEnabled: '',
  tenantScope: '',
  productId: '',
}

export const INITIAL_DB_STATE: DbState = {
  displayName: '',
  toolKey: '',
  connectionHost: '',
  port: '',
  databaseName: '',
  status: '',
  tenantId: '',
  productId: '',
  notes: '',
}
